var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthBkgIconRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 183,
    viewBox: "0 0 248 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.2 319.756C332.391 310.15 361.543 265.492 351.983 220.516L322.918 83.7758C313.358 38.7991 268.562 9.85906 223.371 19.4646C178.181 29.0701 149.029 73.7283 158.589 118.705L187.654 255.445C197.214 300.421 242.01 329.361 287.2 319.756Z",
    fill: "#7869B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287.2 319.756V319.756C332.391 310.15 361.543 265.492 351.983 220.516L322.918 83.7758C313.358 38.7991 268.562 9.85906 223.371 19.4646C178.181 29.0701 149.029 73.7283 158.589 118.705L187.654 255.445C197.214 300.421 242.01 329.361 287.2 319.756",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.349 19.2568L222.393 19.6727L286.222 319.964L288.178 319.548L224.349 19.2568Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8678 326.351C109.2 333.802 146.666 308.502 154.125 270.129L176.803 153.464C184.262 115.091 159.002 77.5977 120.669 70.1467C82.3364 62.6956 44.8706 87.9957 37.4115 126.369L14.7342 243.034C7.27516 281.407 32.5353 318.9 70.8678 326.351Z",
    fill: "#4C3A97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8678 326.351V326.351C109.2 333.802 146.666 308.502 154.125 270.129L176.803 153.464C184.262 115.091 159.002 77.5977 120.669 70.1467C82.3364 62.6956 44.8706 87.9957 37.4115 126.369L14.7342 243.034C7.27516 281.407 32.5353 318.9 70.8678 326.351",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.855 326.513C71.5261 326.455 71.1967 326.415 70.8679 326.351C70.539 326.287 70.2185 326.201 69.8918 326.131L119.682 69.9852C120.011 70.0432 120.34 70.0823 120.669 70.1462C120.998 70.2101 121.318 70.2973 121.645 70.3668L71.855 326.513Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.239 300.687C202.23 301.997 223.741 282.754 225.043 257.925L228.999 182.439C230.3 157.61 210.918 136.224 185.927 134.915C160.936 133.605 139.425 152.848 138.123 177.677L134.167 253.162C132.866 277.991 152.248 299.377 177.239 300.687Z",
    fill: "#BDB4E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.239 300.687V300.687C202.23 301.997 223.741 282.754 225.043 257.925L228.999 182.439C230.3 157.61 210.918 136.224 185.927 134.915C160.936 133.605 139.425 152.848 138.123 177.677L134.167 253.162C132.866 277.991 152.248 299.377 177.239 300.687",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.426 134.941L185.428 134.888L176.74 300.661L177.739 300.713L186.426 134.941Z",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 134,
    width: 11,
    height: 168
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.426 134.941L185.428 134.888L176.74 300.661L177.739 300.713L186.426 134.941Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBkgIconRight);
export default __webpack_public_path__ + "static/media/auth-bkg-icon-right.a9781ce9baa078a3655885aac7327d23.svg";
export { ForwardRef as ReactComponent };